import { apiFetch } from "@/lib/api-client";

// GET /api/public/platform-branding -- ORAI's OWN branding, set by a platform admin on
// /admin/branding and readable before sign-in. Each *_path is a path on the API (pass it to
// `logoUrl`); null means "use the artwork built into the app".
export interface PlatformBranding {
  brand_name: string;
  /** False while the name is the built-in one. */
  custom_name: boolean;
  /** The full lockup: the sign-in page and the admin header. */
  logo_path: string | null;
  /** The same lockup for dark mode; the light one is used when this is empty. */
  logo_dark_path: string | null;
  /** The square mark: the navigation rail and the browser tab. */
  icon_path: string | null;
}

export type PlatformSlot = "logo" | "logo-dark" | "icon";

// What every screen shows until the answer arrives -- and if it never does. Mirrors DEFAULT_NAME
// in Backend/app/shared/platform_branding.py.
export const DEFAULT_PLATFORM_BRANDING: PlatformBranding = {
  brand_name: "ORAI Business Suite",
  custom_name: false,
  logo_path: null,
  logo_dark_path: null,
  icon_path: null,
};

export function fetchPlatformBranding(): Promise<PlatformBranding> {
  return apiFetch<PlatformBranding>("/api/public/platform-branding");
}

// The writes below are PLATFORM-admin only (the server checks); each answers with the new branding.

export function renamePlatform(brandName: string | null): Promise<PlatformBranding> {
  return apiFetch<PlatformBranding>("/api/admin/platform-branding", {
    method: "PATCH",
    body: { brand_name: brandName },
  });
}

export function uploadPlatformAsset(slot: PlatformSlot, file: File): Promise<PlatformBranding> {
  const form = new FormData();
  form.append("file", file);
  return apiFetch<PlatformBranding>(`/api/admin/platform-branding/${slot}`, { method: "POST", body: form });
}

export function removePlatformAsset(slot: PlatformSlot): Promise<PlatformBranding> {
  return apiFetch<PlatformBranding>(`/api/admin/platform-branding/${slot}`, { method: "DELETE" });
}

export function resetPlatformBranding(): Promise<PlatformBranding> {
  return apiFetch<PlatformBranding>("/api/admin/platform-branding", { method: "DELETE" });
}
